import { SET_SATSER, SetSatserAction, SetUniversiteterAction, SET_UNIVERSITETER } from './Types';
import { SatserUtlandModel } from '../../Models/SatserUtlandModel';
import LandOgUniversitetModel from '../../../Shared/Scripts/Models/LandOgUniversitetModel';

export function setSatser(satser: SatserUtlandModel): SetSatserAction {
    return {
        type: SET_SATSER,
        payload: satser,
    };
}

export function setUniversiteter(universiteter: Array<LandOgUniversitetModel>): SetUniversiteterAction {
    return {
        type: SET_UNIVERSITETER,
        payload: universiteter
    }
}